// src/pages/ChangePasswordFirst.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';
import '../styles/Auth.css';

export default function ChangePasswordFirst() {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const flag = sessionStorage.getItem('pw_change_required');
    if (!flag) {
      // If someone opens this page manually but the server won’t require it, just go home
      // (harmless; server still enforces)
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!pw || pw.length < 6) return alert('Password must be at least 6 characters.');
    if (pw !== pw2) return alert('Passwords do not match.');
    try {
      setLoading(true);
      await API.patch('/auth/change-password-first', { newPassword: pw });
      sessionStorage.removeItem('pw_change_required');
      alert('Password updated successfully.');
      // token remains valid; backend no longer blocks; go to role/home
      navigate('/');
    } catch (err) {
      alert(err.response?.data?.msg || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>🔑 Set a New Password</h2>
      <p style={{opacity:.8, marginBottom:10}}>
        Your account requires a password change before continuing.
      </p>
      <form onSubmit={submit}>
        <div className="form-group">
          <label>New Password</label>
          <input type="password" value={pw} onChange={e=>setPw(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <input type="password" value={pw2} onChange={e=>setPw2(e.target.value)} required />
        </div>
        <button type="submit" disabled={loading}>{loading ? 'Saving…' : 'Save & Continue'}</button>
      </form>
    </div>
  );
}
